export const ERROR_ID = 'formattedI18NMessage';
